var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeDetail',{attrs:{"source":_vm.source,"osStartTime":_vm.osStartTime,"clientId":_vm.clientId,"list":_vm.source.children,"num":0}})}
var staticRenderFns = []

export { render, staticRenderFns }